/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBodynz">
    <titleInfo @getHide="getHide" :title="title">
<!--      <tab :list="tablist" :active.sync="active"></tab>-->
    </titleInfo>
    <div class="itemBodyMainnz scrollBar" v-if="islist">
      <div  v-for="(item,index) in messageList" :key="index">
        <div class="itemBodyMainItem">
          <div class="name" :title="item.monitorName">{{ item.monitorName }}</div>
          <div class="info">{{ item.riskLevelName }}</div>
          <div class="desc">{{ item.riskName }}</div>
          <div class="rq">{{ item.createTime }}</div>
        </div>
      </div>
    </div>
    <div v-else class="itemBodyMainnz scrollBar">
      <div class="nodata">
        暂无数据
      </div>

    </div>
  </div>
</template>

<script>
import titleInfo from "@/components/titleInfo";
import tab from "./components/tab";
import Axios from "@/utils/Axios";
export default {
  name: "index",
  components: {titleInfo, tab},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      status: '',
      active: 0,
      tablist: [{
        name: '更多',
        id: 0,
      }],
      islist:false,
      messageList: [{
        name: '',
        info: '',
        desc: '',
        rq: '',
      },
      ]
    }
  },
  watch: {},
  mounted() {
    this.queryTableList()
    this.initWebSocket()
  },
  methods: {
    // 初始化一个 websocket 对象，同时给基本属性赋值
    initWebSocket: function () {

      var token = sessionStorage.getItem("token");

      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https，此处传入需要跟后台连接的接口路径
      // this.websock = new WebSocket( "wss://www.dianct.com/websocket/risk?authorization=" + token); //正式服
      this.websock = new WebSocket("wss://www.wha518.com/websocket/risk?authorization=" + token);//测试服

      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      // this.websock.onclose = this.websocketclose;
    },
    // 定义 websocket open属性的函数
    websocketonopen: function () {
      // this.websock.send(token)
      console.log("WebSocket连接成功risk666");
    },
    // 定义 websocket onerror属性的函数
    websocketonerror: function (e) {
      console.log("WebSocket连接发生错误");
    },
    // 定义 websocket onmessage属性的函数
    websocketonmessage: function (e) {

      let that = this;
      let mess = e.data;
      console.log(e)
      setTimeout(function(){
        that.queryTableList()
      },1000)



    },
    queryTableList() {
      let param = {
        method: "post",
        url: "/portal/getUnHandledRisks",
        params: {},
      };
      Axios.ajax(param).then((res) => {

        this.messageList = res.data;
        if(
          this.messageList.length
        )
        {
          this.islist=true
        }

      });
    },
    getHide() {
      this.$emit('getHide', 0)
    },
  }
}
</script>

<style lang="scss" scoped>
.itemBodynz {
  position: relative;
  width: 100%;
  height: 100%;

  .itemBodyMainnz {
    width: 100%;
    position: relative;
    height: calc(100% - 50px);

    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: column;
    align-content: flex-start;
    overflow-y: scroll;
    .itemBodyMainItem {
      width: calc(100% - 30px);
      background: url("../../../assets/home/item6bg2.png") no-repeat;
      height: 36px;
      background-size: 100% 100%;
      margin-bottom: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      .time {
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #CDF7FF;
        line-height: 14px;
        text-shadow: 0px 1px 1px rgba(3, 21, 110, 0.3);
      }

      .name {
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #CDF7FF;
        margin-left:40px;
        width: 200px;
        overflow:hidden;

        white-space: nowrap;

        text-overflow: ellipsis;
      }

      .info {
        font-size: 16px;
        font-family: PingFang;
       // font-weight: bold;
        color: #01A3FF;
        width: 80px;
        opacity: 0.8;
        margin-left: 10px;
      }

      .desc {
        color: rgba(202, 234, 255, 1);
        font-size: 16px;
        width: 120px;
        font-family: PingFang;
        //font-weight: bold;
        margin-left: 5px;
      }
      .rq {
        color: rgba(202, 234, 255, 1);
        font-size: 16px;
        font-family: PingFang;
        //font-weight: bold;
        margin-left: 5px;
      }
    }
    .itemBodyMainl {
      width: 40%;
      position: relative;
      height: 100%;
    }

    .itemBodyMainr {
      width: 60%;
      position: relative;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: column;
      align-content: flex-start;

      .Item {
        height: 30%;
        position: relative;
        display: flex;
        /*justify-content: flex-end;*/
        align-items: flex-end;
        flex-wrap: nowrap;
        flex-direction: row;
        width: 100%;
        align-content: flex-start;

        .Iteml {
          background: url("../../../assets/home/stagebg.png") center bottom no-repeat;
          width: 99px;
          height: 100%;
          position: relative;
        }

        .Itemr {
          font-size: 16px;
          font-family: PingFang;
          font-weight: 500;
          color: #47c4ff;
          margin-right: 15px;
          margin-left: 15px;
        }
      }
    }
  }
  .nodata{
    width: 100%;
   text-align: center;
    color: #fff;
    font-size: 24px;

    line-height:100px;

  }
}
</style>
